import { createRouter, createWebHistory } from "vue-router";
import store from "@/store/index";
import { ElMessage } from "element-plus";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
    meta: { navFlag: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/index.vue"),
  },
  {
    path: "/products",
    name: "products",
    component: () => import("@/views/Products/index.vue"),
    meta: { navFlag: true },
  },
  {
    path: "/productDetails",
    name: "productDetails",
    component: () => import("@/views/ProductDetails/index.vue"),
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("@/views/Cart/index.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("@/views/Check/index.vue"),
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("@/views/Pay/index.vue"),
  },
  {
    path: "/custam",
    name: "custam",
    component: () => import("@/views/Custam/index.vue"),
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/views/Account/index.vue"),
    children: [
      {
        path: "/account/order",
        name: "order",
        component: () => import("@/views/Account/order.vue"),
      },
      {
        path: "/account/details",
        name: "details",
        component: () => import("@/views/Account/details.vue"),
      },
      {
        // 路由重定向
        path: "/account",
        redirect: {
          path: "/account/order",
        },
      },
    ],
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () => import("@/views/Foot/about-us.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("@/views/Foot/terms-conditions.vue"),
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/Foot/return-refund-policy.vue"),
  },
  {
    path: "/shipping",
    name: "shipping",
    component: () => import("@/views/Foot/shipping-delivery.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("@/views/Foot/privacy-policy.vue"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("@/views/Foot/contact-us.vue"),
  },

  // 404 页面
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === "/checkout" && !store.state.userInfo.access_token) {
    ElMessage({
      message: "Plase log in first",
      type: "error",
    });

    next("/login");
  } else if (to.path === "/pay" && !store.state.userInfo.access_token) {
    next("/login");
  } else if (to.path === "/account" && !store.state.userInfo.access_token) {
    next("/login");
  } else {
    next(); // 正常跳转
  }
  next(); // 正常跳转
});

export default router;
